import { Injectable } from '@angular/core';
import { DominioCombo } from '@core/models/dominio';
import { ApiService } from './api.service';
import { DomainCacheService } from './domain-cache.service';

const baseRef = 'pais';
const route = {
  listar: `${baseRef}/todos`,
  listarPorCidade: (idCidade: number) => `${baseRef}/${idCidade}`,
  listarDDI: 'assets/json/DDI-pais.json'
}

@Injectable({
  providedIn: 'root'
})
export class PaisService {

  constructor(
    private apiService: ApiService,
    private domainCache: DomainCacheService
  ) { }

  listar() {
    return this.domainCache.getOrLoad(route.listar, () =>
      this.apiService.get<DominioCombo[]>(route.listar, undefined, undefined, true)
    );
  }

  listarDDI() {
    return this.apiService.getCustomApi<any[]>(route.listarDDI);
  }
}
